import React, { ChangeEvent, useState } from "react";
import { CloseIcon } from "../../../assets/icons";
import PhoneInputComponent from "../../common/PhoneInputComponent";
import { validatePhoneNumber } from "../../../utils";
import { ICustomer } from "../../../@types";
import { sendReceipt } from "../../../backend-services/receipt";
import { Spinner } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { sendInvoiceReminder } from "../../../backend-services";
import SelectedMarkIcon from "../../../assets/icons/SelectedIcon";
import { showToast } from "../../../utils/toastUtils";
import { ShareOption } from "../../Reusable/SendModal/ReusableSendModal";
import { useSubscription } from "../../../context/SubscriptionProvider";
import ButtonCTA from "../../Reusable/ButtonCTA";

interface SendReceiptModalProps {
  setShowSendModal: (showReminder: boolean) => void;
  setIsSending: (showReminder: boolean) => void;
  customer: ICustomer;
  invoiceId?: string;
}

const SendReminderModal = ({
  setShowSendModal,
  customer,
  invoiceId,
  setIsSending,
}: SendReceiptModalProps) => {
  const { hasSubscription } = useSubscription();
  const { t } = useTranslation("invoices");
  const [medium, setMedium] = useState({
    sms: false,
    whatsapp: false,
    email: false,
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [validatePhone, setValidatePhone] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const handleMediumChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setMedium({
      sms: value === "sms",
      whatsapp: value === "whatsapp",
      email: value === "email",
    });
  };

  const handleMediumChanges = (option: string) => {
    setMedium({
      sms: option === "sms",
      whatsapp: option === "whatsapp",
      email: option === "email",
    });
  };

  const handlePhoneNumberChange = (value: string) => {
    if (value) {
      const trimmedValue = value.trim();
      const normalizedValue = trimmedValue.replace(/\D/g, "");

      const isValidPhoneNumber = validatePhoneNumber(normalizedValue);

      if (isValidPhoneNumber) {
        setPhoneNumber("+" + normalizedValue);
        setValidatePhone("");
      } else {
        setValidatePhone("Invalid phone number format");
      }
    } else {
      setPhoneNumber("");
      setValidatePhone("");
    }
  };
  const handlePhoneNumberKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.currentTarget.value.length >= 17) {
      event.preventDefault();
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      if (invoiceId) {
        const res = await sendInvoiceReminder(invoiceId, medium);
        if (res) {
          showToast("Reminder sent successfully", "success");
          setIsSending(true);
          setShowSendModal(false);
        }
      }
    } catch (error) {
      showToast("Failed to send reminder. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  const [makingUpdate, setMakingUpdate] = useState(false);
  const isLoadingState = (value: boolean) => {
    setMakingUpdate(value);
  };
  return (
    <>
      <div className="bg-gray-900 bg-opacity-50 fixed top-0 right-0 left-0 z-50 h-[100vh]">
        <div className="flex items-end justify-center md:items-center h-full w-full">
          <div
            className={`overflow-y-auto overflow-x-hidden fixed md:top-[25%] w-full md:w-[500px] p-6  bg-white rounded-[12px]`}
          >
            <div className="flex justify-between items-center cursor-pointer mb-2">
              <h1 className="text-[16px] md:text-[24px]  leading-7 font-medium">
                Send Reminder
              </h1>
              <div onClick={() => setShowSendModal(false)}>
                <CloseIcon color="#0A0A0A" />
              </div>
            </div>
            <p className="text-[16px] font-medium md:text-[16px] text-start leading-5 text-[#292D32] mb-7">
              Send manual reminders to clients before or after invoice due dates
            </p>
            <div className="my-5 flex flex-col gap-3 text-left">
              <ShareOption
                enabled={medium.email}
                hasPremium={true}
                main={customer?.email || ""}
                className=""
                onToggle={() => handleMediumChanges("email")}
                title={"Share Via Email"}
                label="email"
                placeholder="Enter Customer Email Address"
                isLoadingState={isLoadingState}
                customerId={customer?.id}
              />
              <ShareOption
                enabled={medium.sms}
                hasPremium={hasSubscription()}
                main={customer?.phone || ""}
                className=""
                onToggle={() => handleMediumChanges("sms")}
                title={"Share Via SMS"}
                warningText={"Upgrade your plan to access this feature"}
                label="phone"
                placeholder="Enter Customer Phone Number"
                isLoadingState={isLoadingState}
                customerId={customer?.id}
              />
              <ShareOption
                enabled={medium.whatsapp}
                hasPremium={hasSubscription()}
                main={customer?.phone || ""}
                className=""
                onToggle={() => handleMediumChanges("whatsapp")}
                title={"Share Via WhatsApp"}
                warningText={"Upgrade your plan to access this feature"}
                label="phone"
                placeholder="Enter Customer Phone Number"
                isLoadingState={isLoadingState}
                customerId={customer?.id}
              />
            </div>

            <ButtonCTA
              onClick={handleSubmit}
              disabled={makingUpdate}
              className="w-full"
            >
              Send Reminder
            </ButtonCTA>
          </div>
        </div>
      </div>
    </>
  );
};
export default SendReminderModal;
